import React from "react";
import styles from "./styles.module.css";
import chartSvg from "../../../Assets/images/chart/1.svg";
import chartSvg1 from "../../../Assets/images/chart/1_1.svg";

export default function CardKPI({ key, data }) {
  console.log('Data',data);
  
  return (

    <div key={key && key} className="w-full mt-2">
      <h1 className="text-xl font-bold mb-4">{data.heading}</h1>
      
      
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 `}
      >
        {data.contents.length
          ? data.contents.map(({ Icon, label, count }, i) => (
              <div
                key={i}
                className={`${styles.kpiCard} p-4  flex flex-col gap-4 `}
              >
                
                <div className="flex gap-4 items-center w-full">
                  <p className={styles.pIcon}>
                    <Icon />
                  </p>
                  <p className="font-bold text-lg">{label}</p>
                </div>
                <div className="flex justify-between items-end">
                  <p className="font-bold text-lg">{count}</p>
                  <span className="relative">
                    <img src={chartSvg} alt="chart" className="block" />
                    <img
                      src={chartSvg1}
                      alt="chart"
                      className="block absolute top-[11px]"
                    />
                  </span>
                </div>
              </div>
            ))
          : ""}
      </div>
    </div>
  );
}
